import { render, staticRenderFns } from "./bank-account.vue?vue&type=template&id=05305f0d&scoped=true&"
import script from "./bank-account.vue?vue&type=script&lang=js&"
export * from "./bank-account.vue?vue&type=script&lang=js&"
import style0 from "./bank-account.vue?vue&type=style&index=0&id=05305f0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05305f0d",
  null
  
)

export default component.exports